import React from 'react';
import { ImagesProvider } from 'contexts/ImagesContext';
import ButtonMatching from 'components/fragments/ButtonMatching/ButtonMatching';
const ButtonMatchingComponent = (props) => (
  <ImagesProvider
    intro={false}
    r={require.context(
      'components/fragments/ButtonMatching/',
      true,
      /\.(png|jpe?g|svg|gif)$/
    )}
  >
    <ButtonMatching {...props} />
  </ImagesProvider>
);

export default ButtonMatchingComponent;
